import { Injectable } from '@angular/core';
import { APP_CONFIG, Env } from '../../environment';
import { ConfigProvider } from '../config/config';
import { ProviderUtilities } from '../provider-utilities';
// import LogrocketFuzzySearch from 'logrocket-fuzzy-search-sanitizer';
import FuzzySearch from 'fuzzy-search-sanitizer-logrocket'

const logRocketPrivateFieldNames = [
  'password',
  'passphrase',
  'currentpassword',
  'newpassword',
  'confirmpassword',
  'cardnumber',
  'cvv',
  'cvn',
  'cardsecuritycode',
  'accountexpirationmonth',
  'accountexpirationyear',
  'accountnumber',
  'securityquestionanswer1',
  'securityquestionanswer2',
  'securityquestionanswer3',
  'answer',
  'securityquestions',
  'fingerprint',
  'access-token',
  'access_token',
  'accesstoken',
  'refreshtoken',
  'refresh_token',
  'devicetoken',
  'device_token',
  'devicesimcard',
  'firstName',
  'middleName',
  'lastName',
  'lastName1',
  'lastName2',
  'recipientFirstName',
  'recipientLastName',
  'phoneNumber',
  'phonenumber',
  'phonenumbervalue',
  'mobilephone',
  'email',
  'emailAddress',
  'emailaddress',
  'otp',
  'providedfields',
  'firstname',
  'lastname',
  'address',
  'unitNumber',
  'city',
  'state',
  'address',
  'postalCode',
  'securityQuestions',
  'areaCode',
  'number',
  'phoneNumberNoAreaCode',
  'phoneNumberFormatted',
  'areaCode',
  'pin',
  'bankAccountNumber',
  'bankAccountNumberUnitary',
  'bankBicSwift',
  'telephoneNumber',
  'telephoneNumberCell',
  'idDocumentNumber',
  'mobileWalletAccountNo',
  'billingAddress',
  'billingCity',
  'billingState',
  'billingPostalCode',
  'zipcode',
  'jwtToken',
  'BinNumber',
  'Authorization',
  'VerifiedDevice',
  'Code',
  'bearer',
  'dateofbirth',
  'customeridno',
  'accountexpirationmonth',
  'accountexpirationyear',
  'age',
  'transactionpin',
  'newtransactionpin',
  'userInput',
  'username',
  'loginToken',
  'securityCode',
  'deviceId',
  'BankName',
  'bankLocationName',
  'bankLocationNumber',
  'bankLocationCity',
  'BeneficiaryFirstName',
  'BeneficiaryFirstLastName',
  'BeneficiarySecondLastName',
  'CustomerFirstName',
  'CustomerLastName',
  'CustomerLastName2',
  'PendingSigninToken',
  'token'
];

// using a customized fuzzy search module to be able to make full matches using the following array
const logRocketFieldsMatchCase  = ["age", "token"];

export const logRocketFuzzySearch = new FuzzySearch(logRocketPrivateFieldNames, logRocketFieldsMatchCase);

export enum LoggerLevel {
  Debug = 'Debug',
  Trace = 'Trace',
  Notice = 'Notice',
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
  Critical = 'Critical',
  Exception = 'Exception',
  Context = 'Context'
}

export class LoggerEntry {
  seqNr: number;
  seqNrParent: number;
  seqNrChilds: string;
  level: LoggerLevel;
  date: Date;
  user: string;
  scope: string;
  source: string;
  event: LoggerEvent;
  message: string;
  details: string;
  parent: LoggerEntry;
  childs: LoggerEntry[];
  sessionId;
  parentSessionId;
  debugHeaders: { [name: string]: string };
  debugParent: LoggerEntry;

  createEvent() {
    const ev = {
      eventName: this.event.toString(),
      startTime: this.date,
      user: this.user
    };
    for (let i = 0; i < this.childs.length; i++) {
      const child = this.childs[i];
      if (child.event)
        ev[child.event.toString()] = child.message;
      ev['endTime'] = child.date;
    }
    return ev;
  }
}

@Injectable()
export class LoggerProvider {
  static appVersion = '0.1.0.0 (fallback)';
  static uuid;
  static globalSessionId;  
  static sessionId;
  static parentSessionId;
  static appInfo = {};
  static seqNr: number = 1;
  static user: string;
  static scope: string = '';
  static entries: LoggerEntry[] = [];
  static debugEntries: LoggerEntry[] = [];
  static preStartEntries: LoggerEntry[] = [];
  static logTimeout;
  static hasStarted: boolean = false;
  static hasErrors: boolean = false;
  static lastSend: Date;
  static callbacks = [];
  static amplitudeSessionId = '';

  static ignoredLogs = 0;
  static cappedLogs = 0;
  static seqNrLast = 0;
  static failedSends = 0;
  static failedSendError;
  static logRocket;
  static profilerStart: Date = new Date();

  logout() {
    LoggerProvider.user = null;
    LoggerProvider.generateSessionId();
  }

  static generateSessionId() {
    if (!this.parentSessionId)
      this.parentSessionId = this.sessionId;

    const date = new Date();
    this.sessionId = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + '-' + date.getHours() + '-' +
                     date.getMinutes() + '-' + date.getSeconds() + '-' + date.getMilliseconds() + '-' + this.uuid;

    if (!this.uuid) {
      if (Math.random() >= 0.5)
        this.sessionId += '0';
      else
        this.sessionId += '1';
    }

    if (!this.globalSessionId)
      this.globalSessionId = this.sessionId;
  }

  static async startLog(http) {
    this.hasStarted = true;

    try {
      for (const entry of this.preStartEntries) {
        this.processLogEntry(entry);
      }
      this.preStartEntries = [];

      if (this.entries.length > 0) {
        let secs = 0;
        if (this.lastSend)
          secs = (new Date().getTime() - this.lastSend.getTime());

        let sendtimer = ConfigProvider.settings.logSendTimerMs;
        if (this.failedSends >= ConfigProvider.settings.logFailedSends)
          sendtimer = ConfigProvider.settings.logErrorTimerMs;

        if (this.hasErrors || secs >= sendtimer) {
          for (let i=0; i < this.entries.length; i++) {
            const entry = this.entries[i];
            if (entry.parent)
              entry.seqNrParent = entry.parent.seqNr;
            if (entry.childs) {
              entry.seqNrChilds = '';
              for (let c=0; c < entry.childs.length; c++) {
                if (c > 0)
                  entry.seqNrChilds += ',';
                entry.seqNrChilds += entry.childs[c].seqNr;
              }
            }

            if (!entry.sessionId)
              entry.sessionId = this.sessionId;
            entry.parent = null;
            entry.childs = null;
          }

          if (this.entries && this.entries.length > 0) {
            const payload = {
              messages: [],
            }

            const seqNrStart = this.seqNrLast;
            const seqNrLast = this.seqNr;
            const payloadDetails = {
              ignoredLogs: this.ignoredLogs, // to inform the server side
              cappedLogs: this.cappedLogs, // to inform the server side
              failedSends: this.failedSends,
              lastSend: this.lastSend,
              date: new Date(),
              dateLast: this.lastSend,
              uuid: this.uuid,
              appVersion: this.appVersion,
              appInfo: this.appInfo,              
              sequenceNrStart: seqNrStart, // to ensure integrity on the server side
              sequenceNrLast: seqNrLast, // to ensure integrity on the server side
              failedSendError: this.failedSendError,
              hasErrors: this.hasErrors,
              entries: null
            };

            payload.messages.push({
              message: JSON.stringify(payloadDetails),
              date: new Date()
            });

            this.entries.forEach((e: any) => {
              e.childs = null;
              e.ignoredLogs = this.ignoredLogs;              
              e.cappedLogs = this.cappedLogs;              
              e.failedSends = this.failedSends;              
              e.lastSend = this.lastSend;
              e.sequenceNrStart = seqNrStart;
              e.sequenceNrLast = seqNrLast;
              e.seqNrParent = '999';
              payload.messages.push({
                message: JSON.stringify(e),
                date: e.date,
              });
            });

            if (APP_CONFIG.phpApiBaseUrl) {
              try {
                payloadDetails.entries = this.entries;
                await http.postExtern(`${APP_CONFIG.phpApiBaseUrl}log.php`, payloadDetails, {}, 'json');
                this.debug(this, 'Logs to PHP sent successfully');
              }
              catch (ex) {
                this.debug(this, 'Failed to send logs to PHP');
              }
            }

            try {
              // post logs to API
              if(APP_CONFIG.logsApiUrl){
                await http.post(`${APP_CONFIG.logsApiUrl}log`, payload);
                this.failedSends = 0;
                this.failedSendError = null;
                this.debug(this, 'Logs sent successfully');
              }else{
                this.debug(this, 'Logs API URL not set');
              }
            }
            catch (ex) {
              this.failedSends++;
              this.failedSendError = { error: 'Failed to send logs', details: ex };
              this.debug(this, 'Failed to send logs');
            }
          }

          this.entries = [];
          this.hasErrors = false;
          this.ignoredLogs = 0;
          this.cappedLogs = 0;
          this.seqNrLast = this.seqNr;
          this.lastSend = new Date();
        }
        else if (!this.lastSend)
          this.lastSend = new Date();
      }
    }
    catch (ex) {
      this.debug(this, 'Exception during logs check');
      this.failedSends++;
      this.failedSendError = { error: 'Exception during logs check', details: ex };
    }

    this.logTimeout = window.setTimeout(() => {
      this.logTimeout = null;
      this.startLog(http);
    }, ConfigProvider.settings.logCheckTimerMs);
  }

  static getLogLevelAsInt(level) {
    if (level === LoggerLevel.Debug)
      return 0;
    else if (level === LoggerLevel.Trace)
      return 1;
    else if (level === LoggerLevel.Notice)
      return 2;
    else if (level === LoggerLevel.Info)
      return 3;
    else if (level === LoggerLevel.Warning)
      return 4;
    else if (level === LoggerLevel.Error)
      return 5;
    else if (level === LoggerLevel.Critical)
      return 6;
    else if (level === LoggerLevel.Exception)
      return 7;
    else if (level === LoggerLevel.Context)
      return 8;
    return 100;
  }

  static log(source, level: LoggerLevel, event: LoggerEvent, message: string, details = null): LoggerEntry {
    for (let i = 0; i < this.callbacks.length; i++) {
      if (!this.callbacks[i](source, level, event, message, details)) {
        this.ignoredLogs++;
        return;
      }
    }

    const whitelist = ',' + ConfigProvider.settings.logWhiteList + ',';
    const blacklist = ',' + ConfigProvider.settings.logBlackList + ',';
    if (whitelist.indexOf(event) === -1) {
      if (this.getLogLevelAsInt(level) < this.getLogLevelAsInt(ConfigProvider.settings.logMinimumLevel) ||
          blacklist.indexOf(event) >= 0) {
        this.ignoredLogs++;
        return;
      }
    }

    if (message && typeof message !== 'string') {
      try {
        message = JSON.stringify(message, null, 2);
      }
      catch (ex) {
        message = 'Unable to stringify message';
      }
    }
    if (details && typeof details !== 'string') {
      try {
        details = JSON.stringify(details, null, 2);
      }
      catch (ex) {
        details = 'Unable to stringify details';
      }
    }
    if (details === '{}' || details === 'null')
      details = null;

    const entry = new LoggerEntry();
    entry.seqNr = this.seqNr;
    entry.level = level;
    entry.date = new Date();
    entry.user = this.user;
    entry.scope = this.scope;
    entry.event = event;
    entry.sessionId = this.sessionId;
    entry.parentSessionId = this.amplitudeSessionId; // send the amplitude session ID here to it gets through to Kibana
    entry.message = message;
    entry.details = details;
    if (source instanceof LoggerEntry) {
      entry.parent = source;
      if (!source.childs)
        source.childs = [];
      source.childs.push(entry);
    }
    while (this.entries.length >= ConfigProvider.settings.logMaxSize) {
      this.cappedLogs++;
      this.entries.shift();
    }
    this.entries.push(entry);

    if (APP_CONFIG.env !== Env.PROD) {
      if (this.debugEntries.length >= 1000) {
        this.debugEntries.pop();
      }
      this.debugEntries.unshift(entry)
      if (source instanceof LoggerEntry)
        this.setDebugProperty(entry, 'debugParent', source);
    }

    this.seqNr++
    let error = false;
    if (this.isErrorLevel(level))
      this.hasErrors = true;

    if (this.hasStarted)
      this.processLogEntry(entry);
    else {
      while (this.preStartEntries.length >= 200) {
        this.preStartEntries.shift();
      }  
      this.preStartEntries.push(entry);
    }

    return entry;
  }

  static isErrorLevel(level) {
    if (level === LoggerLevel.Error || level === LoggerLevel.Critical || level === LoggerLevel.Exception)
      return true;
    return false;
  }

  static processLogEntry(entry) {
    let message = entry.message;
    let details = entry.details;
    let error = false;
    if (this.isErrorLevel(entry.level))
      error = true;

    let seqNr: any = entry.seqNr;
    if (seqNr && entry.parent && entry.parent.seqNr)
      seqNr = seqNr.toString() + ' of ' + entry.parent.seqNr;
    if (LoggerProvider.logRocket) {
      let logFunc = LoggerProvider.logRocket.log;
      if (error) {
        if (APP_CONFIG.enableLogToConsole)
          logFunc = console.error;
        else
          logFunc = LoggerProvider.logRocket.error;
      }
      else if (entry.level === LoggerLevel.Warning) {
        if (APP_CONFIG.enableLogToConsole)
          logFunc = console.warn;
        else
          logFunc = LoggerProvider.logRocket.warn;
      }
      else if (APP_CONFIG.enableLogToConsole)
        logFunc = console.log;
      
      message = LoggerProvider.maskFuzzy(message);
      logFunc('[' + seqNr + '] Level: ' + entry.level + ' / Event: ' + event + ' / Scope: ' + entry.scope + ' / Message: ' + message);
      if (details) {
        details = LoggerProvider.maskFuzzy(details);
        logFunc(details);
      }
    }      
    else if (APP_CONFIG.enableLogToConsole) {      
      if (error) {
        // tslint:disable-next-line:no-console      
        console.error('[' + seqNr + '] Level: ' + entry.level + ' / Event: ' + event + ' / Scope: ' + entry.scope + ' / Message: ' + message );
        if (details) {
          // tslint:disable-next-line:no-console
          console.warn(details);          
        }
      }      
      else if (entry.level === LoggerLevel.Warning)      {
        // tslint:disable-next-line:no-console      
        console.group('[' + seqNr + '] Level: ' + entry.level + ' / Event: ' + event + ' / Scope: ' + entry.scope + ' / Message: ' + message );
        if (details) {
          // tslint:disable-next-line:no-console
          console.warn(details);
        }
        // tslint:disable-next-line:no-console
        console.groupEnd();
      }
      else {
        // tslint:disable-next-line:no-console      
        console.groupCollapsed('[' + seqNr + '] Level: ' + entry.level + ' / Event: ' + event + ' / Scope: ' + entry.scope + ' / Message: ' + message );
        if (details) {
          // tslint:disable-next-line:no-console
          console.log(details);
        }
        // tslint:disable-next-line:no-console
        console.groupEnd();
      }
    }
  }

  static maskFuzzy(message) {
    if (!message)
      return '';

    try {
      if (typeof message === 'object')
        message = JSON.stringify(message);
      else if (typeof message === 'string') {
        if ((<any>message).trimStart().indexOf('{') === -1)
          return message;
      }
      else
        return message;

      const log = {
        body: message,
        method: '',
        headers: {},
      };
      const result = logRocketFuzzySearch.requestSanitizer(log);
      return result.body;
    }
    catch (ex) {
      return 'Unable to mask';
    }
  }

  static debug(source, message, details = null): LoggerEntry {
    return this.log(source, LoggerLevel.Debug, null, message, details);
  }

  static trace(source, message, details = null): LoggerEntry {
    return this.log(source,  LoggerLevel.Trace, null, message, details);
  }  

  static notice(source, message, details = null): LoggerEntry {
    return this.log(source, LoggerLevel.Notice, null, message, details);
  }

  static info(source, message, details = null): LoggerEntry {
    return this.log(source,  LoggerLevel.Info, null, message, details);
  }

  static warning(source, event: LoggerEvent, message: string, details = null): LoggerEntry {
    return this.log(source, LoggerLevel.Warning, event, message, details);
  }

  static error(source, event: LoggerEvent, message: string, details = null): LoggerEntry {
    return this.log(source, LoggerLevel.Error, event, message, details);
  }

  static critical(source, event: LoggerEvent, message: string, details = null): LoggerEntry {
    return this.log(source, LoggerLevel.Critical, event, message, details);
  }

  static exception(source, exception, event: LoggerEvent, message: string, details = null): LoggerEntry {
    if (!exception)
      exception = 'Unknown exception';
    
    if (exception instanceof Error) {
      exception = exception.name + '\r\n' + exception.message + '\r\n' + exception.stack
    }
    else if (typeof exception !== 'string') {
      try {
        exception = JSON.stringify(exception, null, 2);
      }
      catch (ex) {
        exception = 'Unable to stringify exception';
      }
    }      
    details = exception + '\r\n\r\n' + details;
    return this.log(source, LoggerLevel.Exception, event, message, details.trim());
  }

  static context(log: LoggerEntry, event: LoggerEvent, value: string = null, details = null) {
    this.log(log, LoggerLevel.Context, event, value, details);
  }

  static getDebugText(entries: LoggerEntry[] = this.debugEntries) {
    let debug = '';
    const maxlen = 2000;
    for (let i=0; i < entries.length; i++) {
      const entry = entries[i];
      if (i > 0)
        debug += '\r\n'
      const header = ProviderUtilities.formatDate(entry.date, true, false) + ' [' + entry.level + '][' + entry.seqNr + ']: ';
      if (entry.message) {
        debug += header + entry.message.substr(0, maxlen);
        if (entry.message.length > maxlen)
          debug += '...';
      }
      if (entry.details) {
        debug += '\r\n' + header + entry.details.substr(0, maxlen);
        if (entry.details.length > maxlen)
          debug += '...';
      }
    }

    return debug;
  }

  static attachDebugHeaders(entry: LoggerEntry, headers: any) {
    if (!entry || !headers || typeof headers !== 'object' || APP_CONFIG.env === Env.PROD)
      return;
    this.setDebugProperty(entry, 'debugHeaders', this.maskDebugHeaders(headers));
  }

  private static setDebugProperty(entry: LoggerEntry, name: string, value: any) {
    Object.defineProperty(entry, name, {
      value,
      enumerable: false,
      configurable: true,
      writable: true
    });
  }

  static maskDebugHeaders(headers: any): { [name: string]: string } {
    const result: { [name: string]: string } = {};
    const isHttpHeaders = typeof headers.keys === 'function' && typeof headers.get === 'function';
    const names: string[] = isHttpHeaders ? headers.keys() : Object.keys(headers);
    names.forEach((name) => {
      const raw = isHttpHeaders ? headers.get(name) : headers[name];
      if (raw === null || raw === undefined)
        return;
      result[name] = this.maskDebugHeaderValue(name, String(raw));
    });
    return result;
  }

  private static maskDebugHeaderValue(name: string, value: string): string {
    const lowerName = name.toLowerCase();
    const sensitive = /authorization|bearer|cookie|token|jwt|secret|password|signature|api-?key/i.test(name) ||
      logRocketPrivateFieldNames.some((field) => field.toLowerCase() === lowerName);
    if (!sensitive) {
      if (value.indexOf('{') < 0)
        return value;
      const masked = this.maskFuzzy(value);
      return typeof masked === 'string' ? masked : JSON.stringify(masked);
    }
    const scheme = /^(bearer|basic|token)\s+(.*)$/i.exec(value);
    const credential = scheme ? scheme[2] : value;
    if (!credential || credential === 'null' || credential === 'undefined')
      return value;
    return scheme ? scheme[1] + ' ***' : '***';
  }

  static startProfiler() {
    LoggerProvider.profilerStart = new Date();
    return LoggerProvider.profilerStart;
  }

  static getProfileTime(profilerStart = LoggerProvider.profilerStart) {
    const duration =  new Date().getTime() - profilerStart.getTime();
    return duration;
  }

  static profileLogEntry(profilerStart, source, message, details = null): LoggerEntry {
    message += ' (' + LoggerProvider.getProfileTime(profilerStart) + ' ms)';
    return this.info(source,  message, details);
  }

  static profileLog(source, message, details = null, resetTimeAfterwards = true): LoggerEntry {
    const log = LoggerProvider.profileLog(LoggerProvider.profilerStart, source, message, details);
    if (resetTimeAfterwards)
      LoggerProvider.startProfiler();
    return log;
  }
}

export enum LoggerEvent {
  Unknown = 'Unknown',
  // General Plugin Errors / Exceptions
  PluginError = 'PluginError',
  //Plaid Events
  PlaidEvent = 'PlaidEvent',
  // Navigation
  NavigationEnter = 'NavigationEnter',
  NavigationLeave = 'NavigationLeave',
  // HTTP events
  IpEvent = 'IpEvent',
  CommunicationSend = 'CommunicationSend',
  CommunicationReceive = 'CommunicationReceive',
  CommunicationError = 'CommunicationError',
  ConnectionError = 'ConnectionError',
  ResponseAction = 'ResponseAction',
  ResponseStopAction = 'ResponseStopAction',
  Session = 'Session',
  // Login events
  CustomerDisabled = 'CustomerDisabled',
  CustomerLocked = 'CustomerLocked',
  CheckPrices = 'CheckPrices',
  Popup = 'Popup',
  CustomerInvalidSecurityQuestion = 'CustomerInvalidSecurityQuestion',
  KeyChain = 'KeyChain',
  // Check price events
  SelectCountry = 'SelectCountry',
  SelectPaymentMethod = 'SelectPaymentMethod',
  SelectDeliveryMethod = 'SelectDeliveryMethod',
  SelectCurrency = 'SelectCurrency',
  EnterAmountFrom = 'EnterAmountFrom',
  EnterAmountTo = 'EnterAmountTo',
  OpenPromo = 'OpenPromo',
  RejectedPromo = 'RejectedPromo',
  EnterPromo = 'EnterPromo',
  UsePromo = 'UsePromo',
  // Send money events,
  FailedVerifyIdentity = 'FailedVerifyIdentity',
  // Payment methods
  BankAccountFailedVerification = 'BankAccountFailedVerification',
  // Recipient
  LocationFailed = 'LocationFailed',
  // Map
  MapInit = 'MapInit',
  MapSearch = 'MapSearch',
  // Segment
  SegmentInit = 'SegmentInit',
  Tracking = 'Tracking',
  // Cordova
  CordovaGeolocation = 'CordovaGeolocation',
  // Providers
  PushNotifications = 'PushNotifications',
  Payment = 'Payment',
  DeepLinking = 'DeepLinking',
  Veriff = 'Veriff',
  Signicat = 'Signicat',
  // Pages
  SettingsPage = 'SettingsPage',
  WalletCheckLimitsPage = 'WalletCheckLimitsPage',
  SendMoneyPage = 'SendMoneyPage',
  RecipientPage = 'RecipientPage',
  PaymentAccountPage = 'PaymentAccountPage',
  TrackTransferPage = 'TrackTransferPage',
  StoreLocatorPage = 'StoreLocatorPage',
  ActivityPage = 'ActivityPage',
  PreLoginPage = 'PreLoginPage',
  RegistrationPage = 'RegistrationPage',
  SigninPage = 'SigninPage',
  CheckPricesPage = 'CheckPricesPage',
  Wallet = 'Wallet',
  WalletCard = 'Wallet card',
  Recipients = 'Recipients',
  DocUpload = 'Doc Upload',
  CardVerificationRequiredPage = 'CardVerificationRequiredPage',
  // UI Events
  UIClick = 'UIClick',
  UIFocus = 'UIFocus',
  UIEnter = 'UIEnter',
  UISelect = 'UISelect',
  // General
  SubmitAttempt = 'SubmitAttempt',
  Continue = 'Continue',
  Cancel = 'Cancel',
  Info = 'Info',
  FormError = 'FormError',
  // Errors
  UnhandledException = 'UnhandledException',
  ExceptionMessage = 'ExceptionMessage',
  ExceptionStack = 'ExceptionStack',
  GeneralException = 'GeneralException',
  PageException = 'PageException',
  ComponentException = 'ComponentException',
  ProviderException = 'ProviderException',
  LoadingTimeout = 'LoadingTimeout',
  RootDetection = 'RootDetection',
  Firebase = 'Firebase',
  SlowCatpcha = 'SlowCatpcha',
  CaptchaException = 'CaptchaException',
  StorageException = 'StorageException',
  OrderTimeout = 'OrderTimeout',
  ReferaFriend = 'Refer a Friend',
  MobileTopupProvider = 'MobileTopupProvider',
  TransactionLoad = 'transaction',
  AccertifyException = 'AccertifyException',
  Singpass = 'Singpass',
  SlideExists = 'SlideExists',
  InvalidPhoneNumber = 'InvalidPhoneNumber',
  IDFAPluginException= 'IDFAPluginException',
  Vue = 'Vue',
  LastTransactionRate= 'LastTransactionRate',
  SocialLogin = 'SocialLogin',
  setLoginToken = 'setLoginToken',
  BetaTester = 'BetaTester',
  Captcha = 'Captcha',
  OtpTimerException = 'otpTimerException'
}


// WEBPACK FOOTER //
// ./src/providers/logger/logger.ts